<div
  class="fixed inset-0 z-[9999] flex justify-center items-center bg-mj-gris-7 bg-opacity-80 transition-opacity duration-300 ease-in-out"
  [ngClass]="{
    'opacity-0 pointer-events-none': !statusPopup,
    'opacity-100': statusPopup
  }"
>
  <div class="flex flex-col justify-center items-center">

    
    <div class="w-11/12 max-w-[1000px] relative">
        <button (click)="cerrar()" class="absolute w-7 h-7 rounded-full border-white border-2 shadow-lg -right-3 -top-3 bg-white transition ease-in-out delay-150 hover:scale-125">
            <mat-icon class=" text-gray-500 font-black search__icon" matPrefix
              [svgIcon]="'mdi:close'"></mat-icon>
        </button>
        <a [href]="dataPopup?.url_page" target="_blank" >
          <img [src]="url_s3+dataPopup?.url_img_web" alt="Logo" class="w-full hidden md:flex" />
          <img [src]="url_s3+dataPopup?.url_img_mobile" alt="Logo" class="w-full flex md:hidden" />

        </a>
    </div>

  </div>
</div>
